import { IconProps } from '@models/icons';

function Receipt({
    size, color, className, ...rest
}:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
            className={`icon ${className}`}
            {...rest} >
            <mask id="path-1-inside-1_8134_19615" fill="white">
                <rect x="6.09375" y="6.66667" width="14.5833" height="16.6667" rx="1.09375"/>
            </mask>
            <rect x="6.09375" y="6.66667" width="14.5833" height="16.6667" rx="1.09375" stroke={color} strokeWidth="4"
                mask="url(#path-1-inside-1_8134_19615)"/>
            <path
                d="M19.6367 14.2H22.8138C23.4179 14.2 23.9076 14.6897 23.9076 15.2937V19.0441C23.9076 20.8562 22.4385 22.3253 20.6263 22.3253H19.5"
                stroke={color} strokeWidth="2"/>
            <path d="M11 13H16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M11 17H16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    );
}

export default Receipt;
